import {
	Box,
	Button,
	Heading,
	Spacer,
	Stack,
	Table,
	TableContainer,
	Tbody,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import UsuarioTableItem from '../../components/Usuarios/TablaUsuarios/UsuarioTableItem';
import { getAllUsuarios } from '../../services/usuarios';
import Layout from '../../components/Layout/Layout';
import { useNavigate } from 'react-router-dom';
import { AddIcon } from '@chakra-ui/icons';

const ListarUsuarios = () => {
	const [usuarios, setUsuarios] = useState([]);
	const [needReload, setNeedReload] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		const getUsuarios = async () => {
			const users = await getAllUsuarios();
			setUsuarios(users);
			setNeedReload(false);
		};

		needReload && getUsuarios();
	}, [needReload]);

	return (
		<Layout>
			<Box w='100%'>
				<Heading textAlign='center' color='blue.800'>
					USUARIOS
				</Heading>
			</Box>
			<Stack direction='row' mt={-10}>
				<Spacer />
				<Button
					colorScheme='blue'
					rounded='none'
					onClick={() => navigate('/usuarios/crear')}
				>
					<AddIcon />
				</Button>
			</Stack>
			<Box mt={6}>
				<TableContainer
					w='100%'
					border='1px'
					borderColor='blue.400'
					rounded='lg'
					shadow='dark-lg'
					overfloX='auto'
					overflowY='auto'
				>
					<Table
						size={{ base: 'sm', md: 'md', lg: 'lg' }}
						variant='simple'
						whiteSpace='nowrap'
					>
						<Thead bgColor='blue.100'>
							<Tr>
								<Th>Nombre y apellidos</Th>
								<Th>Tipo identificador</Th>
								<Th>Identificador</Th>
								<Th>Telefono trabajo</Th>
								<Th>Telefono personal</Th>
								<Th>Correo</Th>
								<Th>Agencia</Th>
								<Th>Rol</Th>
							</Tr>
						</Thead>
						<Tbody>
							{usuarios &&
								usuarios.map(usuario => {
									return (
										<UsuarioTableItem
											key={usuario.uuid}
											usuario={usuario}
										/>
									);
								})}
						</Tbody>
					</Table>
				</TableContainer>
			</Box>
		</Layout>
	);
};

export default ListarUsuarios;
